import HttpService from '@/services/http/http.service';


export default class AdminMachineService {
	constructor() {
		this.http = new HttpService();
	}

	createMachine(courseId, machine) {
		const data = {
			name: machine.name,
			type: machine.type,
		};

		if (machine.type === 'gcp') {
			data.gcp = machine.gcp;
			data.gcp.disks = data.gcp.disks.map((disk) => {
				disk.size = Number(disk.size);
				return disk;
			});
		}

		return this.http.post(`admin/course/${courseId}/machine`, data);
	}

	updateMachine(courseId, machine) {
		const data = {
			name: machine.name,
		};

		if (machine.type === 'gcp') {
			data.gcp = machine.gcp;
			data.gcp.disks = data.gcp.disks.map((disk) => {
				disk.size = Number(disk.size);
				return disk;
			});
		}

		return this.http.put(`admin/course/${courseId}/machine/${machine.id}`, data);
	}

	removeMachine(courseId, machineId) {
		return this.http.delete(`admin/course/${courseId}/machine/${machineId}`)
	}

	getMachines(page, limit) {
		return this.http.get('admin/machine', {
			page,
			limit,
		});
	}
}
